module.exports = __webpack_public_path__ + "static/media/hydronomad-4.826fa359.jpg";